// extracted by mini-css-extract-plugin
export default {"feesRow":"wire-transfer_feesRow__F+02u","hidden":"wire-transfer_hidden__45HW+"};